import FormSection from "components/forms/FormSection";
import Grid from "@mui/material/Grid";
import FormTextField from "components/common/DTextField";
// import photoService from "services/File/PhotoService";
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    MenuItem,
    Radio,
    RadioGroup
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
    AccountBalanceOutlined,
    AddHomeOutlined,
    CallOutlined,
    HomeOutlined,
    Person,
    PublicOutlined,
    AccountBalanceWalletOutlined
} from "@mui/icons-material";
import employeePayClassResource from "features/maintenance/resources/employeePayClassResource";
import employmentStatusResource from "features/maintenance/resources/employmentStatusResource";
import SelectDateField from "components/common/SelectDataField";
import { usePermission } from "hooks/usePermission";
import { useSelector } from "react-redux";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

export default function PersonalInformationTab({
    form,
    activeEmployee,
    updateField,
    person,
    isNew,
    validateErrors: errors,
    clearFieldError,
    hasPayrollAccess,
    hasEmployeeAccess,
    hasOwnerAccess
}) {
    /*const { canView: hasEmployeeAccess } = usePermission("employee");
    const { canView: hasPayrollAccess } = usePermission("payrollEmployee");
    console.log({ canView, hasPayrollAccess });

    const canExecute = hasEmployeeAccess && isOwner;*/

    const lookUpStatuses = useSelector(
        (state) =>
            state.maintenance[MAINTENANCE_STORE_SELECTORS.EMPLOYMENT_STATUS]
    );

    const lookUpPayClass = useSelector(
        (state) =>
            state.maintenance[MAINTENANCE_STORE_SELECTORS.EMPLOYEE_PAY_CLASS]
    );

    const canSeeOtherInfo = hasEmployeeAccess || hasOwnerAccess; // payroll cant see this

    /* const lookUpPositions = useSelector(
         (state) =>
             state.maintenance[MAINTENANCE_STORE_SELECTORS.EMPLOYEE_POSITION]
     );*/

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5
            }}
        >
            {/* Basic Information */}
            <FormSection title="Basic Information" icon={Person}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            fullWidth
                            label="Employee Number"
                            value={form?.employee?.employeeCode ?? ""}
                            onChange={(e) => {
                                updateField("employee", {
                                    employeeCode: e.target.value
                                });
                                clearFieldError("employee.employeeCode");
                            }}
                            disabled={!isNew}
                            required
                            error={!!errors["employee.employeeCode"]}
                            helperText={errors["employee.employeeCode"]}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        {/* <LookupField
                            fullWidth
                            label="Employment Status"
                            value={form?.employmentStatusName ?? ""}
                            type="lookup"
                            required
                            resource={employmentStatusResource}
                            lookupField="description"
                            sourceDataField="id"
                            targetDataField="employmentStatusId"
                            onChange={(value) => {
                                updateField("employmentStatusId", value?.id);
                                updateField(
                                    "employmentStatusName",
                                    value?.description
                                );
                            }}
                        />*/}

                        {hasEmployeeAccess || hasPayrollAccess ? (
                            <SelectDateField
                                fullWidth
                                label="Employment Status"
                                value={form?.employmentStatusId ?? ""}
                                required
                                resource={employmentStatusResource}
                                displayField="description"
                                sourceDataField="id"
                                targetDataField="employmentStatusId"
                                error={!!errors.employmentStatusId}
                                helperText={errors.employmentStatusId}
                                defaultOptions={lookUpStatuses}
                                onChange={(value) => {
                                    // console.log({ value });
                                    updateField(
                                        "employmentStatusId",
                                        value?.id
                                    );
                                    clearFieldError("employmentStatusId");
                                }}
                            />
                        ) : (
                            <FormTextField
                                fullWidth
                                label="Employment Status"
                                value={form?.employmentStatusName ?? ""}
                                error={!!errors.employmentStatusName}
                                helperText={errors.employmentStatusName}
                                onChange={() => ""}
                                disbaled
                            />
                        )}
                    </Grid>
                    {/* <Grid size={{ xs: 12, md: 4 }}>
                        <LookupField
                            fullWidth
                            label="Pay Class"
                            value={form?.payClassName ?? ""}
                            type="lookup"
                            required
                            resource={employeePayClassResource}
                            lookupField="description"
                            sourceDataField="id"
                            targetDataField="payClassId"
                            onChange={(value) => {
                                updateField("payClassId", value?.id);
                                updateField("payClassName", value?.description);
                            }}
                        />
                    </Grid>*/}
                    <Grid size={{ xs: 12, md: 4 }}>
                        {hasEmployeeAccess || hasPayrollAccess ? (
                            <SelectDateField
                                fullWidth
                                label="Pay Class"
                                value={form?.payClassId ?? ""}
                                required
                                resource={employeePayClassResource}
                                displayField="description"
                                sourceDataField="id"
                                targetDataField="payClassId"
                                error={!!errors.payClassId}
                                helperText={errors.payClassId}
                                defaultOptions={lookUpPayClass}
                                onChange={(value) => {
                                    clearFieldError("payClassId");
                                    updateField("payClassId", value?.id);
                                }}
                            />
                        ) : (
                            <FormTextField
                                fullWidth
                                label="Pay Class"
                                value={form?.payClassName ?? ""}
                                error={!!errors.payClassName}
                                helperText={errors.payClassName}
                                onChange={() => ""}
                                disbaled
                            />
                        )}
                    </Grid>
                    {/*<Grid size={{ xs: 12, md: 8 }} />*/}
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            fullWidth
                            label="First Name"
                            value={form?.firstName ?? ""}
                            onChange={(e) => {
                                updateField("firstName", e.target.value);
                                clearFieldError("firstName");
                            }}
                            error={!!errors.firstName}
                            helperText={errors.firstName}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormTextField
                            fullWidth
                            label="Middle Name"
                            value={form?.middleName ?? ""}
                            onChange={(e) =>
                                updateField("middleName", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            fullWidth
                            label="Last Name"
                            value={form?.lastName ?? ""}
                            onChange={(e) => {
                                updateField("lastName", e.target.value);
                                clearFieldError("lastName");
                            }}
                            error={!!errors.lastName}
                            helperText={errors.lastName}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 1 }}>
                        <FormTextField
                            fullWidth
                            label="Suffix"
                            value={form?.suffix ?? ""}
                            onChange={(e) =>
                                updateField("suffix", e.target.value)
                            }
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            fullWidth
                            type="date"
                            label="Date of Birth"
                            value={
                                form?.dateOfBirth
                                    ? form.dateOfBirth.substring(0, 10)
                                    : null
                            }
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                            onChange={(e) =>
                                updateField("dateOfBirth", e.target.value)
                            }
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 5 }}>
                        <FormTextField
                            fullWidth
                            type="text"
                            label="Place of Birth"
                            value={form?.placeOfBirth}
                            onChange={(e) =>
                                updateField("placeOfBirth", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormControl>
                            <FormLabel>Sex</FormLabel>

                            <RadioGroup
                                row
                                value={form?.sex ?? ""}
                                onChange={(e) =>
                                    updateField("sex", e.target.value)
                                }
                            >
                                <FormControlLabel
                                    value="M"
                                    control={<Radio />}
                                    label="Male"
                                />
                                <FormControlLabel
                                    value="F"
                                    control={<Radio />}
                                    label="Female"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            select
                            fullWidth
                            label="Civil Status"
                            defaultValue=""
                            value={form?.civilStatus ?? ""}
                            onChange={(e) =>
                                updateField("civilStatus", e.target.value)
                            }
                        >
                            <MenuItem value="Single">Single</MenuItem>
                            <MenuItem value="Married">Married</MenuItem>
                            <MenuItem value="Widowed">Widowed</MenuItem>
                            <MenuItem value="Separated">Separated</MenuItem>
                            <MenuItem value="Annuled">Annuled</MenuItem>
                            <MenuItem value="Others">Others</MenuItem>
                        </FormTextField>
                    </Grid>
                    <Grid size={{ xs: 2.5 }}>
                        <FormTextField
                            label={`Height(mtr)`}
                            value={form?.height ?? null}
                            onChange={(e) =>
                                updateField("height", e.target.value || null)
                            }
                            type="number"
                        />
                    </Grid>
                    <Grid size={{ xs: 2.5 }}>
                        <FormTextField
                            label="Weight(Kg)"
                            value={form?.weight ?? null}
                            onChange={(e) =>
                                updateField("weight", e.target.value || null)
                            }
                            type="number"
                        />
                    </Grid>
                    <Grid size={{ xs: 3 }}>
                        <FormTextField
                            label="Blood Type"
                            value={form?.bloodType ?? null}
                            onChange={(e) =>
                                updateField("bloodType", e.target.value || null)
                            }
                        />
                    </Grid>
                </Grid>
            </FormSection>

            {/* Address Information */}
            <FormSection
                title="Address Information"
                icon={HomeOutlined}
                hide={!canSeeOtherInfo}
            >
                <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mb: 2 }}
                >
                    Residential Address
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <FormTextField
                            label="Street Address"
                            value={form?.addressStreet ?? ""}
                            onChange={(e) =>
                                updateField("addressStreet", e.target.value)
                            }
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <FormTextField
                            label="Subdivision"
                            value={form?.addressSubdivision ?? ""}
                            onChange={(e) =>
                                updateField(
                                    "addressSubdivision",
                                    e.target.value
                                )
                            }
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <FormTextField
                            label="Barangay"
                            value={form?.addressBarangay ?? ""}
                            onChange={(e) =>
                                updateField("addressBarangay", e.target.value)
                            }
                        />
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 5 }}>
                                <FormTextField
                                    label="City / Municipality"
                                    value={form?.addressCity ?? ""}
                                    onChange={(e) =>
                                        updateField(
                                            "addressCity",
                                            e.target.value
                                        )
                                    }
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }}>
                                <FormTextField
                                    label="Province"
                                    value={form?.addressProvince ?? ""}
                                    onChange={(e) =>
                                        updateField(
                                            "addressProvince",
                                            e.target.value
                                        )
                                    }
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 3 }}>
                                <FormTextField
                                    label="ZIP Code"
                                    value={form?.addressZipCode ?? ""}
                                    onChange={(e) =>
                                        updateField(
                                            "addressZipCode",
                                            e.target.value
                                        )
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </FormSection>

            {/* Secondary Address Information */}
            <FormSection
                title="Secondary Address Information"
                icon={AddHomeOutlined}
                hide={!canSeeOtherInfo}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12 }}>
                        <FormTextField
                            label="Address"
                            multiline
                            rows={4}
                            value={form?.residentialAddress ?? ""}
                            onChange={(e) =>
                                updateField(
                                    "residentialAddress",
                                    e.target.value
                                )
                            }
                        />
                    </Grid>
                </Grid>
            </FormSection>

            {/* Contact Information */}
            <FormSection
                title="Contact Information"
                icon={CallOutlined}
                hide={!canSeeOtherInfo}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormTextField
                            label="Personal Email"
                            value={form?.emailPersonal ?? ""}
                            onChange={(e) =>
                                updateField("emailPersonal", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormTextField
                            label="Company Email"
                            value={form?.emailCompany ?? ""}
                            onChange={(e) =>
                                updateField("emailCompany", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            label="Mobile Number"
                            value={form?.mobileNumber ?? ""}
                            onChange={(e) =>
                                updateField("mobileNumber", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            label="Telephone Number"
                            value={form?.telephoneNumber ?? ""}
                            onChange={(e) =>
                                updateField("telephoneNumber", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormTextField
                            label="Extension"
                            value={form?.telephoneNumberExt ?? ""}
                            onChange={(e) =>
                                updateField(
                                    "telephoneNumberExt",
                                    e.target.value
                                )
                            }
                        />
                    </Grid>
                </Grid>
            </FormSection>

            {/* Government Information */}
            <FormSection
                title="Government Information"
                icon={AccountBalanceOutlined}
                hide={!canSeeOtherInfo}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormTextField
                            label="SSS Number"
                            value={form?.sss ?? ""}
                            onChange={(e) => updateField("sss", e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormTextField
                            label="TIN"
                            value={form?.tin ?? ""}
                            onChange={(e) => updateField("tin", e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormTextField
                            label="GSIS"
                            value={form?.gsis ?? ""}
                            onChange={(e) =>
                                updateField("gsis", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormTextField
                            label="PAG-IBIG"
                            value={form?.pabIbig ?? ""}
                            onChange={(e) =>
                                updateField("pabIbig", e.target.value)
                            }
                        />
                    </Grid>
                </Grid>
            </FormSection>

            {/* Citizenship */}
            <FormSection
                title="Citizenship"
                icon={PublicOutlined}
                hide={!canSeeOtherInfo}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormTextField
                            label="Citizenship"
                            value={form?.citizenship ?? ""}
                            onChange={(e) =>
                                updateField("citizenship", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormTextField
                            label="Country"
                            value={form?.countryPrimary ?? ""}
                            onChange={(e) =>
                                updateField("countryPrimary", e.target.value)
                            }
                        />
                    </Grid>
                </Grid>
            </FormSection>

            {/* Banking Information */}
            <FormSection
                title="Banking Information"
                icon={AccountBalanceWalletOutlined}
                hide={!canSeeOtherInfo && !hasPayrollAccess}
            >
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormTextField
                            label="Bank Name"
                            value={form?.bankName ?? ""}
                            onChange={(e) =>
                                updateField("bankName", e.target.value)
                            }
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormTextField
                            label="Bank Account Number"
                            value={form?.bankAccountNumber ?? ""}
                            onChange={(e) =>
                                updateField("bankAccountNumber", e.target.value)
                            }
                        />
                    </Grid>
                </Grid>
            </FormSection>
        </Box>
    );
}
